import { render } from "./customerInventory.vue?vue&type=template&id=42003e58&scoped=true"
import script from "./customerInventory.vue?vue&type=script&lang=js"
export * from "./customerInventory.vue?vue&type=script&lang=js"

import "./customerInventory.vue?vue&type=style&index=0&id=42003e58&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42003e58"]])

export default __exports__